import type { ExceptionField } from '@/api/cockpit';

export function resolveFieldValue(field: ExceptionField, fields: Record<string, string>): string {
  return fields[field.key] ?? field.value;
}
